// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subtitle {
  color: #6c757d;
  margin: 0 0 20px 0;
  font-size: 14px;
}

h3 {
  font-size: 18px;
  margin-bottom: 15px;
}

.text-muted {
  font-size: 14px;
}

.alert {
  display: flex;
  align-items: center;
  gap: 12px;
}
.alert mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/ai-connections/ai-connections.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AACJ","sourcesContent":[".subtitle {\n  color: #6c757d;\n  margin: 0 0 20px 0;\n  font-size: 14px;\n}\n\nh3 {\n  font-size: 18px;\n  margin-bottom: 15px;\n}\n\n.text-muted {\n  font-size: 14px;\n}\n\n.alert {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
